import dayjs from 'dayjs';
import { DeclarationType } from '../../app.constants';
import { Coordinates } from '../coordinates.model';
import { UUID } from '../uuid.model';
import { IDeclaration } from './declaration.interface';

export class Declaration implements IDeclaration {
  constructor(
    public id: UUID,
    public level: number,
    public instant: dayjs.Dayjs,
    public texte?: string,
    public photos: string[] = [],
    public idZone?: string,
    public declareePourZone?: boolean,
    public location?: Coordinates,
    public type?: DeclarationType
  ) {}

  public static hydrate(declaration: Declaration): Declaration {
    return new Declaration(
      declaration.id,
      declaration.level,
      dayjs(declaration.instant),
      declaration.texte,
      Object.assign([], declaration.photos),
      declaration.idZone,
      declaration.declareePourZone,
      declaration.location,
      declaration.type
    );
  }
}
